module.exports = __webpack_public_path__ + "img/growthAbility10.0380a13a.png";